module.exports = __webpack_public_path__ + "img/progress_063.33e53322.png";